import { getAttachmentId } from './resourceUpload'

const getPdfTemplateItem = (boxes = {}) => {
  const pdfItems = Object.values(boxes || {}).filter(
    (item) => item?.type === 'pdf',
  )

  return (
    pdfItems.find(
      (item) => getAttachmentId(item) || getAttachmentId(item?.pdf),
    ) || pdfItems[0]
  )
}

const getPdfTemplateAttachmentId = (item = {}) =>
  getAttachmentId(item) || getAttachmentId(item?.pdf)

export const isPdfTemplateRevisionChanged = (
  currentTemplate = {},
  nextTemplate = {},
) => {
  const currentSha256 = `${currentTemplate?.sha256 || ''}`.trim()
  const nextSha256 = `${nextTemplate?.sha256 || ''}`.trim()

  if (currentSha256 && nextSha256) {
    return currentSha256 !== nextSha256
  }

  const currentAttachmentId = `${currentTemplate?.attachmentId || ''}`.trim()
  const nextAttachmentId = `${nextTemplate?.attachmentId || ''}`.trim()

  return Boolean(
    currentAttachmentId &&
      nextAttachmentId &&
      currentAttachmentId !== nextAttachmentId,
  )
}

export const hasIncompatiblePdfOverlayGeometry = (
  boxes = {},
  pdfTemplate = {},
) => {
  const templateSha256 = `${pdfTemplate?.sha256 || ''}`.trim()
  if (!templateSha256) return false

  return Object.values(boxes || {}).some((item) => {
    if (item?.type === 'pdf' || item?.pdfPlacement?.version !== 2) return false

    const placementSha256 = `${
      item?.pdfPlacement?.templateSha256 || ''
    }`.trim()

    return Boolean(placementSha256 && placementSha256 !== templateSha256)
  })
}

export const clearPdfOverlayGeometry = (boxes = {}) => {
  let hasChange = false
  const nextBoxes = { ...boxes }

  Object.keys(nextBoxes).forEach((id) => {
    const item = nextBoxes[id]
    if (
      item?.type === 'pdf' ||
      (!item?.pdfPlacement && !item?.pdfTextStyle)
    ) {
      return
    }

    const nextItem = { ...item }
    delete nextItem.pdfPlacement
    delete nextItem.pdfTextStyle
    nextBoxes[id] = nextItem
    hasChange = true
  })

  return hasChange ? nextBoxes : boxes
}

export const isPdfTemplateMetadataPending = (boxes = {}, layout = {}) => {
  const pdfTemplateItem = getPdfTemplateItem(boxes)
  const attachmentId = getPdfTemplateAttachmentId(pdfTemplateItem)

  if (!attachmentId) return false

  return (
    attachmentId !== `${layout?.pdfTemplate?.attachmentId || ''}`.trim() ||
    !`${layout?.pdfTemplate?.sha256 || ''}`.trim()
  )
}
